import React, { useContext } from "react";
import AppContext from '@/modules/storefront/hooks/appContext';

export function truncateStringEllipsis(str, n){
    return (str.length > n) ? str.substr(0, n-1) + '...' : str;
};

export function getCartTotal (cart, property){
    return cart.reduce( function(a, b){
        return a + b[property[0].amount];
    }, 0);
}

export function findVariantAmounts(product, currentCurrency, activeAttributes) {
    if (!product?.variants.length > 0) {
        let currencyAmount = product.amounts.find((amount) => amount.currency_id === currentCurrency);
        console.log(currencyAmount);
        console.log(currentCurrency);
        return currencyAmount.amount ?? 0;
    }
    const variant = product?.variants?.find((variant) => {
        return activeAttributes?.every((option) => {
            const matchingOption = variant.options.find((vOption) => vOption.label === option.label && vOption.value === option.value);
            return !!matchingOption;
        });
    });
    return variant ? variant.amounts?.find((amount) => amount.currency_id === currentCurrency)?.amount : 0;
}

export function calcCartTotal (cart, currentCurrency) {
    let totalAmount = 0;

    cart.forEach((product) => {
        if (product.variants.length === 0) {
            const amount = product.amounts.find((amount) => amount.currency_id === currentCurrency);
            if (amount) {
                totalAmount += parseFloat(amount.amount) * product.qty;
            }
        } else {
            const matchingVariant = product.matchingVariant;
            const matchedVariant = product.variants.find((variant) => {
                return matchingVariant.every((mv) =>
                  variant.options.some((vOption) =>
                    vOption.label === mv.label && vOption.value === mv.value
                  )
                );
            });

            if (matchedVariant) {
                const amount = matchedVariant.amounts.find((amount) => amount.currency_id === currentCurrency);
                if (amount) {
                    totalAmount += parseFloat(amount.amount) * product.qty;
                }
            }
        }
    });

    return totalAmount;

    // let total = 0
    // for ( let i = 0; i<cart.length; i++ ) {
    //     let productMultiple = findVariantAmounts(cart[i], currentCurrency, activeAttributes) * cart[i].qty;
    //     // let productMultiple = cart[i].amounts[0].amount * cart[i].qty;
    //     total += productMultiple;
    // }
    // return total
}

export function calcCartTax (cart, taxPct, deliveryFee, discount, type, currentCurrency, activeAttributes) {
    let cartTotal = calcCartTotal(cart, currentCurrency, activeAttributes);

    let cartDiscount = 0;
    let deliveryCharge = 0;
    if (discount) {
        cartDiscount = calcCartDiscount(cart, deliveryFee, discount, type, currentCurrency, activeAttributes)

        // let deliveryCharge = 0;
        if (deliveryFee > 0) {
            deliveryCharge = deliveryFee;
        }
    } else {
        if (deliveryFee > 0) {
            deliveryCharge = deliveryFee;
        }
    }

    let taxDec = taxPct/100;
    let cartTax = (parseInt(cartTotal) + parseInt(deliveryCharge) - parseInt(cartDiscount)) * taxDec;

    return cartTax;
}

export function calcCartDiscount (cart, deliveryFee, discount, type, currentCurrency, activeAttributes) {
    let cartTotal = calcCartTotal(cart, currentCurrency, activeAttributes);
    
    let deliveryCharge = 0;
    if (deliveryFee > 0) {
        deliveryCharge = deliveryFee;
    }

    let discountAmount = 0;
    if (type === "percent") {
        discountAmount = (discount / 100) * (parseInt(cartTotal) + parseInt(deliveryCharge));
    } else if (type === "flat") {
        discountAmount = (parseInt(discount));
    }
    return discountAmount.toFixed(2);
}

export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e)
    }
};

export const formatToMoney = num => {
    num = parseFloat(num) ?? 0;
    if (num === 0 || isNaN(num)) return "0.00";
    return (Math.floor(Number(num) * 100) / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

export const capFirstLetter = (word) => {
    const capitalizedText = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

    return capitalizedText;
}